module.exports = __webpack_public_path__ + "img/solidstrategy.7e8f4b53.png";